<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">新規契約申し込み</span>
              <span class="breadcrumb-link current">新規契約申し込み内容の確認</span>
              <span class="breadcrumb-link">新規契約申し込みの完了</span>
            </div>
            <h1 class="hdg02">お申し込み内容の確認</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>

          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容をご確認いただき、「契約を申し込む」ボタンを押下して申し込みを確定してください。</p>
              <h2 class="hdg03 mb32">お申し込み内容</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          法人名/個人名 
                        </th>
                        <td>
                          {{ group1.name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          読み仮名 
                        </th>
                        <td>
                          {{ group1.kana }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご担当者名 
                        </th>
                        <td>
                          {{ group1.charge_name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ご担当部署名 
                        </th>
                        <td>
                          {{ group1.department }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          郵便番号/住所  
                        </th>
                        <td>
                          〒 {{ group1.postnumber }}<br>
                          {{ group1.address }}{{ group1.address2 }}{{ group1.address3 }}<br>
                          {{ group1.address4 }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          メールアドレス 
                        </th>
                        <td>
                          {{ group1.email }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          職業  
                        </th>
                        <td>
                          {{ group1.selectedOccupationClassificationName }}<br>
                          {{ group1.selectedOccupationName }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          電話番号1 
                        </th>
                        <td>
                          {{ group1.tel }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          電話番号2
                        </th>
                        <td>
                          {{ group1.tel2 }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          内線番号
                        </th>
                        <td>
                          {{ group1.extension }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAX番号
                        </th>
                        <td>
                          {{ group1.fax }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          弊社紹介社員
                        </th>
                        <td>
                          {{ group1.introducer }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col style="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          備考
                        </th>
                        <td v-html="group1.noteDisp"></td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03 estimate-print-ttl">購入を希望するパッケージ</h2>
              <a href="/lc/app/public/print/new-application-print" target="_blank" class="estimate-print txt-blue">お見積もり印刷画面を表示 <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
              <div class="purchase-summary mb40">
                <p class="purchase-summary-heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ group1.totalFeeDisp }}</strong>円（税込）</p>
              </div>

              <!-- PCの場合 -->
              <div class="visible-pc mb40">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" 
                  class="tbl04 box-package">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ item.sub_total_fee_disp }}</strong>円（税込）</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <colgroup>
                        <col style="width:35%;">
                        <col style="width:15%;">
                        <col style="width:35%;">
                        <col style="width:15%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th class="ta-center">商品名</th>
                          <th class="ta-center">ライセンス数</th>
                          <th class="ta-center">ライセンス期間</th>
                          <th class="ta-center">価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                          <th>
                            <div class="tbl04-table-txt">{{ item2.name }}</div>
                          </th>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                          </td>
                          <td class="ta-right">
                            <div class="tbl04-table-txt">{{ item2.price_disp }} 円</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <template v-if="item.option_products.length > 0">
                      <div class="tbl04-bodyarea-hdg">
                        <h4 class="hdg04">オプション</h4>
                      </div>
                      <table class="tbl04-table">
                        <colgroup>
                          <col style="width:30%;">
                          <col style="width:15%;">
                          <col style="width:40%;">
                          <col style="width:15%;">
                        </colgroup>
                        <thead>
                          <tr>
                            <th class="ta-center">商品名</th>
                            <th class="ta-center">ライセンス数</th>
                            <th class="ta-center">ライセンス期間</th>
                            <th class="ta-center">価格（税込）</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                            <th class="pl40">
                              <div class="tbl04-table-txt">{{ item3.name }}</div>
                            </th>
                            <td>
                              <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                            </td>
                            <td>
                              <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                            </td>
                            <td class="ta-right">
                              <div class="tbl04-table-txt">{{ item3.price_disp }} 円</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </template>
                  </div>
                </div>
              </div>

              <!-- SPの場合 -->
              <div class="visible-sp mb40">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="heading-sub"><span>ご請求金額</span><br class="visible-sp">合計<strong>{{ item.sub_total_fee_disp }}</strong>円（税込）</p>
                  </div>
                  <div class="tbl04-bodyarea">

                    <table class="tbl04-table">
                      <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                        <td>
                          <div class="tbl04-table-txt txt-bold">{{ item2.name }}</div>
                        </td>
                        <th>ライセンス数</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                        </td>
                        <th>ライセンス期間</th>
                        <td>
                          <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                        </td>
                        <th>価格（税込）</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.price_disp }} 円</div>
                        </td>
                      </tr>
                    </table>
                    <template v-if="item.option_products.length > 0">
                      <div class="tbl04-bodyarea-hdg">
                        <h4 class="hdg04">オプション</h4>
                      </div>
                      <table class="tbl04-table">
                        <tr v-for="(item3, index3) in item.option_products" :key="'option_' + index3">
                          <td>
                            <div class="tbl04-table-txt txt-bold">{{ item3.name }}</div>
                          </td>
                          <th>ライセンス数</th>
                          <td>
                            <div class="tbl04-table-txt">{{ item3.license_number }}</div>
                          </td>
                          <th>ライセンス期間</th>
                          <td>
                            <div class="tbl04-table-txt">12カ月（{{ group1.licensePeriodStart }}～{{ group1.licensePeriodEnd }}）</div>
                          </td>
                          <th>価格（税込）</th>
                          <td>
                            <div class="tbl04-table-txt">{{ item3.price_disp }} 円</div>
                          </td>
                        </tr>
                      </table>
                    </template>
                  </div>
                </div>
              </div>

              <h2 class="hdg03 sp-ml20">お支払い方法</h2>
              <div class="contract-content-payment mb40">
                <p class="txt">{{ group1.paymentName }}</p>
              </div>

              <div class="contact-submit">
                <router-link to="/public/new-application/index" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.onSubmitButtonClicked">契約を申し込む</button>
                </div>
              </div>

            </div>
          </form>

        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import * as logicNewApplication from '@/logic/public/NewApplication'

export default defineComponent({
  components: {
  },
  setup (props, context) {
    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicNewApplication.getGroupConfirm(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact {
  @media screen and (max-width:$width-container) {
    &-head {
      .hdg02 {
        padding-top: 20px;
      }
    }
  }

  .contact-submit-button .btn {
    color: $color-link;
    background-color: #FFF;
  }

  .estimate-print-ttl {
    display: inline-block;
  } 
  .estimate-print {
    margin-left: 40px;
  }
  .tbl04-hdgarea .heading-sub {
    font-size: 16px;
    line-height: 1.625;
    margin-top: 8px;
    color: $color-content;
    span{
      font-weight: bold;
      margin-right: 25px;
      color: $color-hdg;
    }
    strong{
      font-size: 24px;
      font-weight: bold;
      margin: 0 10px;
      color: $color-hdg;
    }
  }
  .contract-content-payment .txt {
    margin-bottom: 16px;
  }
}
</style>
